import React                                                                                                                    from 'react';
import { PluginDocumentSettingPanel }                                                                                           from '@wordpress/edit-post';
import { CheckboxControl, RadioControl, TextareaControl, TextControl, __experimentalNumberControl as NumberControl }            from '@wordpress/components';
import ProductsAndVariationsCompleter                                                                                           from './ProductsAndVariationsCompleter';
import SelectWithLabel                                                                                                          from '../SelectWithLabel';
import withMetaboxValidation                                                                                                    from './withMetaboxValidation';
import { OrderBumpsMeta, ValidationRules }                                                                                      from '../../Types/ValidationRules';
import {__} from "@wordpress/i18n";

const getValidationRules: ( meta: OrderBumpsMeta ) => ValidationRules = ( meta ) => ( {
    cfw_ob_offer_quantity: {
        required() {
            return meta.cfw_ob_upsell === 'yes';
        },
        number: true,
    },
    cfw_ob_offer_product_v9: {
        required: true,
        error: __('You must select an offer product.', 'checkout-wc'),
    },
} );

const OrderBumpsOfferPanel = ( { meta, handleFieldChange } ) => (
    <PluginDocumentSettingPanel
        name="cfw-ob-display-conditions"
        title={__('Offer', 'checkout-wc')}
        className="cfw-ob-offer-mb"
    >
        <SelectWithLabel
            type="custom"
            label={__('Offer Product', 'checkout-wc')}
            autocompleter={ProductsAndVariationsCompleter}
            placeholder={__( 'Search for product', 'checkout-wc' )}
            multiple={false}
            selected={meta.cfw_ob_offer_product_v9}
            onChange={
                ( newValues: any ) => {
                    handleFieldChange( 'cfw_ob_offer_product_v9', newValues );
                }
            }
        />

        <CheckboxControl
            label={__('Auto Add Order Bump to Cart', 'checkout-wc' )}
            help={__('If conditions are satisfied, automatically add this order bump to the cart. Useful for free gifts or other offers that don\'t require customer action.', 'checkout-wc' ) }
            checked={ meta.cfw_ob_auto_add === 'yes' }
            onChange={
                ( newValue: boolean ) => {
                    handleFieldChange( 'cfw_ob_auto_add', newValue ? 'yes' : 'no' );
                }
            }
        />

        {meta.cfw_ob_upsell !== 'yes' && (
            <CheckboxControl
                label={__('Auto Match Variations Between Search and Offer Product', 'checkout-wc' )}
                help={
                    (
                        <>
                            <span>
                            {__('Add offer product to the cart with the same variable configuration as the product below.', 'checkout-wc')}
                            </span>
                            <br /><br />
                            <span>
                            {__('Only applies when Auto Match Cart Product and Offer Product are variable products with matching variation attributes (Size, Color, etc)', 'checkout-wc')}
                            </span>
                            <br /><br />
                            <span>
                            {__('Leave unchecked to have customers to select variation options in a modal window.', 'checkout-wc')}
                            </span>
                            <br /><br />
                            <span>
                                <strong>{__('If offer product is not variable, this option is ignored.', 'checkout-wc')}</strong>
                            </span>
                        </>
                    )
                }
                checked={ meta.cfw_ob_enable_auto_match === 'yes' }
                onChange={
                    ( newValue: boolean ) => {
                        handleFieldChange( 'cfw_ob_enable_auto_match', newValue ? 'yes' : 'no' );
                    }
                }
            /> )
        }

        {meta.cfw_ob_upsell !== 'yes' && meta.cfw_ob_enable_auto_match === 'yes' && (
            <SelectWithLabel
                type="custom"
                label={__('Auto Match Variations Cart Product', 'checkout-wc')}
                autocompleter={ProductsAndVariationsCompleter}
                placeholder={__( 'Search for product', 'checkout-wc' )}
                multiple={false}
                selected={meta.cfw_ob_variation_match_product}
                help={
                    (
                        <>
                            {__('The product in the cart to match the Order Bump variations to.', 'checkout-wc')}
                        </>
                    )
                }
                onChange={
                    ( newValues: any ) => {
                        handleFieldChange( 'cfw_ob_variation_match_product', newValues );
                    }
                }
            />
        )}

        {meta.cfw_ob_upsell !== 'yes'
                && <>
                    <CheckboxControl
                        label={__('Match Quantity of Offer Product to Display Condition Product', 'checkout-wc')}
                        help={__('If customer has two of the display condition product in the cart, two of the offer product will be added to the cart.', 'checkout-wc')}
                        checked={ meta.cfw_ob_match_offer_product_quantity === 'yes' }
                        onChange={
                            ( newValue: boolean ) => {
                                handleFieldChange( 'cfw_ob_match_offer_product_quantity', newValue ? 'yes' : 'no' );
                            }
                        }
                    />
                </>
        }

        {meta.cfw_ob_match_offer_product_quantity === 'yes' && (
            <SelectWithLabel
                type="custom"
                label={__('Match Quantity Cart Product', 'checkout-wc')}
                autocompleter={ProductsAndVariationsCompleter}
                placeholder={__( 'Search for product', 'checkout-wc' )}
                multiple={false}
                selected={meta.cfw_ob_quantity_match_product}
                help={
                    (
                        <>
                            {__('The product in the cart to match the Order Bump quantity to.', 'checkout-wc')}
                        </>
                    )
                }
                onChange={
                    ( newValues: any ) => {
                        handleFieldChange( 'cfw_ob_quantity_match_product', newValues );
                    }
                }
            />
        )}

        { ( meta.cfw_ob_upsell !== 'yes' && meta.cfw_ob_match_offer_product_quantity !== 'yes' )
            && <>
                <NumberControl
                    label={__('Quantity of Offer Product To Add', 'checkout-wc')}
                    help={__('The quantity to add to the cart when offer is accepted.', 'checkout-wc')}
                    value={ meta.cfw_ob_offer_quantity }
                    onChange={
                        ( newValue: string ) => {
                            handleFieldChange( 'cfw_ob_offer_quantity', newValue );
                        }
                    }
                />
                <CheckboxControl
                    label={__('Allow Customer To Change Quantity In Cart', 'checkout-wc')}
                    help={__('Allow customer to change the quantity of this order bump in the cart.', 'checkout-wc')}
                    checked={ meta.cfw_ob_enable_quantity_updates === 'yes' }
                    onChange={
                        ( newValue: boolean ) => {
                            handleFieldChange( 'cfw_ob_enable_quantity_updates', newValue ? 'yes' : 'no' );
                        }
                    }
                />
            </>
        }
    </PluginDocumentSettingPanel>
);

export default withMetaboxValidation( OrderBumpsOfferPanel, getValidationRules );
